import AcdIcon from './acd.svg';
import DocIcon from './doc.svg';
import EgIcon from './eg.svg';
import EpoaIcon from './epoa.svg';
import FuneralIcon from './funeral.svg';
import PersonalIcon from './personal.svg';
import WillIcon from './will.svg';

export { AcdIcon, DocIcon, EgIcon, EpoaIcon, FuneralIcon, PersonalIcon, WillIcon };
